"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsClient = void 0;
exports.createWebAnalytics = createWebAnalytics;
const client_1 = require("./client");
var client_2 = require("./client");
Object.defineProperty(exports, "AnalyticsClient", { enumerable: true, get: function () { return client_2.AnalyticsClient; } });
const localStorageAdapter = {
    async getItem(key) {
        try {
            return globalThis.localStorage?.getItem(key) ?? null;
        }
        catch {
            return null;
        }
    },
    async setItem(key, value) {
        try {
            globalThis.localStorage?.setItem(key, value);
        }
        catch { /* quota/private mode — ignore */ }
    },
    async removeItem(key) {
        try {
            globalThis.localStorage?.removeItem(key);
        }
        catch { /* ignore */ }
    },
};
function createWebAnalytics(config) {
    const client = new client_1.AnalyticsClient({
        ...config,
        platform: 'web',
        storage: config.storage ?? localStorageAdapter,
    });
    client
        .init()
        .then(() => {
        client.track('app_opened');
        client.track('session_started');
        if (typeof window !== 'undefined') {
            window.addEventListener('pagehide', () => { void client.flush(); });
            window.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    client.notifyActive();
                }
                else {
                    void client.flush();
                }
            });
        }
    })
        .catch((err) => {
        // Analytics must never disrupt the host app. Swallow init failures
        // (typically storage quota / private-mode restrictions) after logging.
        // Subsequent track() calls become no-ops because `initialized` stays
        // false — events queue silently rather than crash.
        // eslint-disable-next-line no-console
        console.warn('[analytics] init failed:', err);
    });
    return client;
}
